import { tokens, css } from '@sail/ui';
import { media } from '@sail/engine';
export const layoutStyles = css.global({
    [media.up(tokens.viewport.xlarge)]: {
        ':root': {
            '--layoutWidth': 'var(--layoutWidthMax)',
            '--gutterWidth': 'calc((var(--windowWidth) - var(--layoutWidth)) / 2)'
        }
    },
    [media.up(tokens.viewport.large)]: {
        ':root': {
            '--columnCountMax': 4
        }
    },
    [media.up(tokens.viewport.small)]: {
        ':root': {
            '--columnCountMax': 2
        }
    },
    ':root': {
        '--scrollbarWidth': '0px',
        '--gutterWidth': '16px',
        '--layoutWidthMax': '1080px',
        '--windowWidth': `calc(100vw - var(--scrollbarWidth))`,
        '--layoutWidth': `calc(var(--windowWidth) - var(--gutterWidth) * 2)`,
        '--columnCountMax': 1,
        '--columnWidth': `calc(var(--layoutWidth) / var(--columnCountMax))`,
        '--columnMaxWidth': `calc(var(--layoutWidthMax) * 0.25)`,
        '--copyMaxWidth': `calc(var(--columnMaxWidth) * 3)`
    }
});

//# sourceMappingURL=layout.js.map